import { h, type FunctionalComponent } from '@stencil/core';
import { getAppName } from '../utils/utils';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';
import {CtaWidget} from '../../../../../widgets/cta-widget/cta-widget';

type CtaWidgetDataProps = Partial<CtaWidget> & { iconName: string; library?: string; };

type CtaPublicWidgetsRowProps = Pick<IDashboardDesktopView, 'country' | 'language' | 'hasCtaProductSelector' | 'hasSupportButton' | 'tabName' | 'analyticsTabName' | 'brand' | 'rtl' | 'labelProvider' >;

export const CtaPublicDesignFirmWidgetsRow: FunctionalComponent<CtaPublicWidgetsRowProps> = (
  props
) => {
    const {
      country,
      tabName,
      brand,
      labelProvider,
    } = props;

    const targetBrand = getAppName(brand);

    const designFirmwidgetData: CtaWidgetDataProps[] = [
      {
        header: labelProvider('dashboardCta.tool.header', 'EcoStruxure™ Specification Tool'),
        content: labelProvider('dashboardCta.tool.content', 'Generate detailed technical specifications for electrical and mechanical requirements!'),
        url: `https://ecostruxure-specification.se.app/${country}/`,
        iconName: 'breaker-signal-waves-left',
      },

      {
        header: labelProvider('dashboardCta.training.header', ' Looking for a training?'),
        content: labelProvider('dashboardCta.training.content', 'Access all available Training Courses tailored to your needs.'),
        url: ' https://schneider-electric.csod.com/ui/lms-learner-home/home',
        iconName: 'graduation-hat',
      },

      {
        header: labelProvider('dashboardCta.solutions.header', 'EcoStruxure™ Solutions for your Business'),
        content: labelProvider('dashboardCta.solutions.content', 'Access all the topics you need in one convenient place.'),
        url: `https://www.se.com/myschneider/content/${country}/en/cc/${country}/general/ecostruxure-for-segments.jsp`,
        iconName: 'cloud-book',
      }
    ];

    return (
      <div class="cta-public-widgets-row--grid ">
        {designFirmwidgetData.map((widget, index) => {
            return <div class="widget-offset-bottom">
              <uiaas-search-cta-widget
                key={index + widget.header}
                {...widget}
                anchor-target="_blank"
                tab-name={tabName}
                event-category="widget-cta-support-button"
              >
                <qds-icon
                  slot="icon"
                  size="large"
                  name={widget.iconName}
                  className="dashboard-widget-icon"
                />
              </uiaas-search-cta-widget>
            </div>;
        })}
      </div>
    );
};
